module.exports = __webpack_public_path__ + "img/home_lhc.1568a150.png";